export const TEST_ID = 'healthCharts';
